import {
  type AlignmentLine,
  type RectangleDrawData,
  type SnapCandidate,
  type SnapDataStyles,
} from './snapTo.types';
import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef, Point } from 'types/documentServices';

const getRectangleStyle = (editorAPI: EditorAPI, compRef?: CompRef) => {
  const isOnMasterPage =
    compRef &&
    (editorAPI.components.isShowOnAllPages(compRef) ||
      editorAPI.components.isShowOnSomePages(compRef));

  if (isOnMasterPage) {
    return {
      fill: 'none',
      stroke: '#fe620f',
    };
  }

  return {
    stroke: '#92fafe',
    fill: 'none',
  };
};

function getRectanglesDrawData(
  editorAPI: EditorAPI,
  compsPointersAndLayouts: SnapCandidate[],
): RectangleDrawData[] {
  return compsPointersAndLayouts.map((compPointerAndLayout) => {
    const { x, y, width, height } = compPointerAndLayout.layout;
    return {
      x,
      y,
      width,
      height,
      style: getRectangleStyle(editorAPI, compPointerAndLayout.comp),
    };
  });
}

const getLine = (
  p1: Point,
  p2: Point,
  style?: SnapDataStyles,
): AlignmentLine => ({
  type: 'alignmentLine',
  line: [p1, p2],
  rectanglesDrawData: [],
  style,
});

export { getLine, getRectanglesDrawData };
